import { Box } from "@mui/material";
import { useRiskLevelStyles } from "./riskLevels.styles";
import { RiskLevelIndicator, riskLevelIndicatorImage } from "./riskLevelIndicators";

export interface IRiskLevelLegend {
    riskLevels: Array<string>;
    riskLevelIndicators: Array<RiskLevelIndicator>;
}

// Maps each risk level's icon (and colour) to its name. Shared by the matrix and the distribution history chart so
// the same colour always carries the same label, wherever the levels are drawn.
export function RiskLevelLegend({ riskLevels, riskLevelIndicators }: IRiskLevelLegend) {
    const styles = useRiskLevelStyles();

    return (
        <Box sx={styles.legend}>
            {riskLevels.map((name, riskLevelIndex) => (
                <Box key={riskLevelIndex} sx={styles.legendItem}>
                    <Box sx={styles.legendIcon}>{riskLevelIndicatorImage(riskLevelIndicators[riskLevelIndex])}</Box>
                    {name}
                </Box>
            ))}
        </Box>
    );
}
